<template>
    <div id = 'main-content'>
      <p v-if = 'drawerMode && groupEditor' class = 'selectSeat' style = 'color: red; font-style: bold;'> {{$t('pages.exams.classrooms.groupEditorTurnedOn')}}</p>
      <h3 class = 'classroom_name'>{{this.classroomStructure.name}} 
        <button class = 'seatMarksButton' v-bind:class = "{'activeProperty': showSeatMarks}" @click.prevent = 'toggleSeatMarks()'><i class = 'fa fa-eye'></i></button>
        <button v-if = 'drawerMode' class = 'seatMarksButton' v-bind:class = "{'activeProperty': showExerciseGroups}" @click.prevent = 'toggleExecGroups()'><i class = 'fa'>♛</i></button>
        <button v-if = 'drawerOnly' class = 'seatMarksButton' @click.prevent = 'increaseSize()'><i class = 'fa fa-plus'></i></button>
        <button v-if = 'drawerOnly' class = 'seatMarksButton' @click.prevent = 'decreaseSize()'><i class = 'fa fa-minus'></i></button>
        <button v-if = 'drawerOnly' class = 'seatMarksButton' @click.prevent = 'resetSize()'><i class = 'fa'>↺</i></button>
        </h3>
      <p v-if = '!drawerMode' class = 'selectSeat'> {{$t('pages.exams.editExam.selectSeat')}}</p>
      <p v-if = 'drawerMode && customColoring' class = 'selectSeat'> {{$t('pages.exams.classrooms.selectColorSeats')}}</p>

    <!-- for quizzes: updates live, interval function -->
      <table id = 'classroom_preview'>
        <tr v-if = '!drawerMode' id = 'classroom-struct'>
          <td class = 'classroom-wing' v-bind:class = '{"classroom-wing-left-side": (wing.id === 0)}' v-for = 'wing in classroomStructure.data' :key = 'wing.id'>
            <tr class = 'classroom-row' v-for = 'row in wing' :key = 'row.id'>
              <div v-if = "row[0].id.split('_')[0] === '0' && showSeatMarks" class = 'rowMark'> {{Number(row[0].id.split('_')[1])}} </div>
              <td v-for = 'seat in row' :key = 'seat.id'>
                <button class = 'seatButton' v-on:click = 'assignSeat(seat.id, seat.exerciseGroup)'>
                  <div v-bind:class = '{"classroom-seat": ( (!drawerMode) && (!seat.assigned) ), "seat-drawer": drawerMode, "selected" : (selectedSeat === seat.id), "taken" : (seat.assigned)}'>
                    <i class="fa fa-check fixCheck" v-if = 'selectedSeat === seat.id'></i>
                    <span v-if = 'showSeatMarks' class = 'seatMark'> {{Number(seat.id.split('_')[2])}} </span>
                </div>
                </button>
              </td>
            </tr>
          </td>
        </tr>

    <!-- drawer mode enabled - assigning seats turned off, no updating status, just sketch -->
        <tr v-else id = 'classroom-struct'>
          <td class = 'classroom-wing' v-bind:class = '{"classroom-wing-left-side": (wing.id === 0)}' v-for = 'wing in classroomStructure.data' :key = 'wing'>
            <tr class = 'classroom-row' v-for = 'row in wing.rows' :key = 'row'>
              <div v-if = "row.id.split('_')[0] === '0' && showSeatMarks" class = 'rowMark'> {{Number(row.id.split('_')[1])}} </div>
              <td v-for = 'seat in row.seats' :key = 'seat'>
                <button class = 'seatButton' v-on:click = 'colorSeat(seat.id)'>
                  <div v-bind:id = seat.id class = 'classroom-seat' v-bind:class = '{"groupA" : seat.exerciseGroup === "A", "groupB" : seat.exerciseGroup === "B", "groupC" : seat.exerciseGroup === "C", "groupD" : seat.exerciseGroup === "D"}'>
                    <span v-if = 'showSeatMarks' class = 'seatMark'> {{Number(seat.id.split('_')[2])}} </span>
                    <p class = 'exerciseGroup' v-if = '(drawerMode) && (showExerciseGroups)'>{{seat.exerciseGroup}}</p>
                </div>
                </button>
              </td>
            </tr>
          </td>
          <td v-if = 'customColoring && !groupEditor' style = 'margin-left: 2em;'>
            <p class = 'selectSeat' style = 'text-align: right'> {{$t('pages.exams.classrooms.selectColors')}} </p>
            <ul class = 'colorPicker'>
              <li v-bind:key = 'color' v-for = 'color in selectColors'><button class = 'colorPickerButton' v-bind:class = '{"selectedColorButton" : selectedColor === color}' v-bind:style = '{background: color}' @click.prevent = 'selectColor(color)'></button></li>
            </ul>
          </td>
          <td v-if = 'customColoring && !groupEditor' style = 'margin-left: 2em;'>
            <p class = 'selectSeat' style = 'text-align: right'> {{$t('pages.exams.classrooms.selectedSeats')}} </p>
            <ul class = 'colorPicker'>
              <li v-bind:key = 'seat' v-for = 'seat in coloredSeatsPicked'>{{seat}}</li>
              <li>Total: {{coloredSeatsCount}}</li>
            </ul>
          </td>
          <td v-if = 'groupEditor' style = 'margin-left: 2em;'>
            <p class = 'selectSeat' style = 'text-align: right'> {{$t('pages.exams.classrooms.selectGroup')}} </p>
            <ul class = 'colorPicker'>
              <li v-bind:key = 'group' v-for = 'group in ["A", "B", "C", "D"]'><button class = 'colorPickerButton' v-bind:class = '{"selectedColorButton" : newGroup === group}' @click.prevent = 'newGroup === group ? newGroup = "" : newGroup = group'>{{group}}</button></li>
            </ul>
          </td>
        </tr>
        <tr class = 'prof-row'>
          <div class = 'prof'>
          </div>
        </tr>
        <tr class = 'prof-row'>
          <button v-if = 'drawerMode && !customColoring && !groupEditor' class = 'showHideExecGroups' @click.prevent = 'toggleCustomColoring()'>{{$t('pages.exams.classrooms.customizeColoring')}}</button>
          <button v-if = 'drawerMode && customColoring && !groupEditor' class = 'showHideExecGroups' @click.prevent = 'toggleCustomColoring()'>{{$t('pages.exams.classrooms.turnOffCustomizeColoring')}}</button>
          <button v-if = 'drawerMode && !groupEditor && !customColoring' class = 'showHideExecGroups' @click.prevent = 'toggleGroupEditor()'>{{$t('pages.exams.classrooms.turnOnGroupEditor')}}</button>
          <button v-if = 'drawerMode && groupEditor' class = 'showHideExecGroups' @click.prevent = 'toggleGroupEditor()'>{{$t('pages.exams.classrooms.turnOffGroupEditor')}}</button>
        </tr>
        <tr v-if = 'drawerMode && !groupEditor' class = 'colorSettings'>
          {{$t('pages.exams.classrooms.colorGroup')}}
          <button style = 'background: green' class = 'colorGroup buttonA' @click.prevent = 'groupColor("groupA")'>A</button>
          <button style = 'background: red' class = 'colorGroup buttonB' @click.prevent = 'groupColor("groupB")'>B</button>
          <button style = 'background: pink' class = 'colorGroup buttonC' @click.prevent = 'groupColor("groupC")'>C</button>
          <button style = 'background: blue' class = 'colorGroup buttonD' @click.prevent = 'groupColor("groupD")'>D</button>
        </tr>
      </table>

      <div id = 'successfullySeated' v-if = 'seated'>
        <h4 class = 'pageText'> {{ $t('pages.exams.classrooms.successfullySeated')}} </h4>
        <button class = 'ready' @click.prevent = 'readyStart()'> START </button>
      </div>
    </div>
</template>

<script>
import Rest from './../../services/rest'
import router from './../../router/router.js'
export default {
  data () {
    return {
      seated: false,
      classroomStructure: {},
      classroomDrawerInfo: {
        wingCount: 0,
        maxSeatCounts: []
      },
      drawerMode: false,
      selectedSeat: '',
      showExerciseGroups: false,
      exerciseGroup: '',
      showSeatMarks: true,
      coloredSeats: [false, false, false, false],
      customColoring: false,
      selectColors: ['#ccff66', '#558000', '#b3d1ff', '#d279d2', '#ffd480', '#009999', '#ffad33', '#660033'],
      selectedColor: '',
      coloredSeatsPicked: [],
      coloredSeatsCount: 0,
      groupEditor: false,
      newGroup: ''
    }
  },
  created () {
    if (!this.drawerOnly) {
      this.checkIfSeated()
    }
    this.setupComponent()
    if (!this.seated && !this.drawerMode) {
      setInterval(() => this.getClassroomStatus(), 1000)
    }
  },
  destroyed () {
    this.selectedClassroom = 0
  },
  props: ['selectedClassroom', 'drawerOnly', 'quizID'],
  methods: {
    setupComponent () {
      this.toggleDrawerMode()
      if (!this.drawerMode) {
        this.setClassroomName()
        this.getClassroomStatus()
      } else {
        this.getClassroomByID()
      }
    },
    checkIfSeated () {
      return Rest.request('GET', `/classExams/${this.quizID}/checkIfSeated`).then((data) => {
        if (data.seatID) {
          this.selectedSeat = data.seatID
          this.seated = true
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    setClassroomName () {
      return Rest.request('GET', `/classrooms/getClassroomName/${this.selectedClassroom}`).then((data) => {
        this.classroomStructure = {
          name: JSON.parse(data.name).name,
          data: {}
        }
      }).catch((err) => {
        console.log(err)
      })
    },
    getClassroomStatus () {
      if (this.selectedClassroom) {
        return Rest.request('GET', `/classExams/${this.quizID}/getClassroomStatus`).then((data) => {
          this.classroomStructure.data = Object.assign({}, this.classroomStructure.data, data.status)
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    getClassroomByID () {
      if (this.selectedClassroom) {
        return Rest.request('GET', `/classrooms/getClassroomByID/${this.selectedClassroom}`).then((data) => {
          this.classroomStructure = data
          this.classroomStructure.name = JSON.parse(this.classroomStructure.classroomInfo).name
          this.classroomStructure.data = JSON.parse(this.classroomStructure.data)
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    assignSeat (seatID, exerciseGroup) {
      if (!this.selectedSeat) {
        let postdata = {
          seatID: seatID,
          quizID: this.quizID
        }
        return Rest.request('PUT', `/classExams/${this.quizID}/assignSeat`, postdata).then((data) => {
          this.seated = true
          this.selectedSeat = seatID
          this.exerciseGroup = exerciseGroup
        }).catch((err) => {
          console.log(err)
        })
      } else {
        let postdata = {
          seatID: this.selectedSeat,
          quizID: this.quizID
        }
        return Rest.request('PUT', `/classExams/${this.quizID}/freeSeat`, postdata).then((data) => {
          this.seated = false
          this.selectedSeat = ''
          this.exerciseGroup = ''
          this.assignSeat(seatID, exerciseGroup)
        }).catch((err) => {
          console.log(err)
        })
      }
    },
    freeSeat () {
      let postdata = {
        seatID: this.selectedSeat,
        quizID: this.quizID
      }
      return Rest.request('PUT', `/classExams/${this.quizID}/freeSeat`, postdata).then((data) => {
        this.seated = false
      }).catch((err) => {
        console.log(err)
      })
    },
    toggleDrawerMode (drawerOnly) {
      if (this.drawerOnly) {
        this.drawerMode = true
      }
    },
    toggleExecGroups () {
      if (this.drawerOnly) {
        this.showExerciseGroups = !this.showExerciseGroups
      }
    },
    toggleSeatMarks () {
      this.showSeatMarks = !this.showSeatMarks
    },
    groupColor (group) {
      switch (group) {
        case 'groupA': {
          if (this.coloredSeats[0] === true) {
            window.jQuery('.' + group).css({'background': 'white', 'color': 'black'})
            window.jQuery('.buttonA').css({'border': '0', 'color': 'white'})
            this.coloredSeats[0] = false
            break
          } else {
            window.jQuery('.' + group).css({'background': 'green', 'color': 'white'})
            window.jQuery('.buttonA').css({'border': '2px solid black', 'color': 'black'})
            this.coloredSeats[0] = true
            break
          }
        }
        case 'groupB': {
          if (this.coloredSeats[1] === true) {
            window.jQuery('.' + group).css({'background': 'white', 'color': 'black'})
            window.jQuery('.buttonB').css({'border': '0', 'color': 'white'})
            this.coloredSeats[1] = false
            break
          } else {
            window.jQuery('.' + group).css({'background': 'red', 'color': 'white'})
            window.jQuery('.buttonB').css({'border': '2px solid black', 'color': 'black'})
            this.coloredSeats[1] = true
            break
          }
        }
        case 'groupC': {
          if (this.coloredSeats[2] === true) {
            window.jQuery('.' + group).css({'background': 'white', 'color': 'black'})
            window.jQuery('.buttonC').css({'border': '0', 'color': 'white'})
            this.coloredSeats[2] = false
            break
          } else {
            window.jQuery('.' + group).css({'background': 'pink', 'color': 'white'})
            window.jQuery('.buttonC').css({'border': '2px solid black', 'color': 'black'})
            this.coloredSeats[2] = true
            break
          }
        }
        case 'groupD': {
          if (this.coloredSeats[3] === true) {
            window.jQuery('.' + group).css({'background': 'white', 'color': 'black'})
            window.jQuery('.buttonD').css({'border': '0', 'color': 'white'})
            this.coloredSeats[3] = false
            break
          } else {
            window.jQuery('.' + group).css({'background': 'blue', 'color': 'white'})
            window.jQuery('.buttonD').css({'border': '2px solid black', 'color': 'black'})
            this.coloredSeats[3] = true
            break
          }
        }
      }
    },
    toggleCustomColoring () {
      this.customColoring = !this.customColoring
      this.resetSize()
      if (!this.customColoring) {
        this.selectedColor = ''
      }
    },
    selectColor (color) {
      this.selectedColor = color
    },
    colorSeat (id) {
      if (this.groupEditor && this.newGroup) {
        this.editGroup(id)
      }
      let currentColor = window.jQuery(`#${id}`).css('background').substring(4, 17).split(', ')
      if (currentColor[0] === '255' && currentColor[1] === '255' && currentColor[2] === '255') {
        if (this.selectedColor && this.customColoring) {
          window.jQuery(`#${id}`).css({'background': this.selectedColor, 'color': 'white'})
          this.coloredSeatsPicked.push(id)
          this.coloredSeatsCount++
        }
      } else {
        if (this.customColoring) {
          window.jQuery(`#${id}`).css({'background': 'rgb(255, 255, 255)', 'color': 'black'})
          this.coloredSeatsPicked.splice(id, 1)
          this.coloredSeatsCount--
        }
      }
    },
    editGroup (id) {
      let postdata = {
        seatID: id,
        group: this.newGroup
      }
      if (confirm(`Ali ste sigurni, da zelite stolu ${id} dodeliti skupino ${this.newGroup}?`)) {
        return Rest.request('POST', `/classrooms/${this.classroomStructure.id}/editGroup`, postdata).then((data) => {
          this.getClassroomByID()
          this.resetSize()
        })
      }
    },
    increaseSize () {
      let currentHeight = window.jQuery('.classroom-seat').height()
      let currentWidth = window.jQuery('.classroom-seat').width()
      window.jQuery('.classroom-seat').animate({height: currentHeight + (currentHeight * 0.1), width: currentWidth + (currentWidth * 0.1)})
    },
    decreaseSize () {
      let currentHeight = window.jQuery('.classroom-seat').height()
      let currentWidth = window.jQuery('.classroom-seat').width()
      window.jQuery('.classroom-seat').animate({height: currentHeight - (currentHeight * 0.1), width: currentWidth - (currentWidth * 0.1)})
    },
    resetSize () {
      window.jQuery('.classroom-seat').css({height: '2.5vh', width: '1vw'})
    },
    toggleGroupEditor () {
      this.groupEditor = !this.groupEditor
    },
    logSeatedUser () {
      let putdata = {
        exerciseGroup: this.exerciseGroup
      }
      return Rest.request('PUT', `/classExams/${this.quizID}/logSeatedUser`, putdata).then((data) => {
        this.seated = true
      }).catch((err) => {
        console.log(err)
      })
    },
    startExamAttempt () {
      let postdata = {
        classExamId: this.quizID
      }
      return Rest.request('POST', `/classExams/${this.quizID}/start`, postdata).then((data) => {
        router.push({name: 'classExam', params: {classExamId: this.quizID}})
        this.logSeatedUser()
      }).catch((err) => {
        console.log(err)
      })
    },
    seatedAssignExecGroup () {
      let seatID = this.selectedSeat.split('_')
      this.exerciseGroup = this.classroomStructure.data[seatID[0]][seatID[1]][seatID[2]].exerciseGroup
    },
    readyStart () {
      this.seatedAssignExecGroup()
      this.startExamAttempt()
    }
  }
}
</script>

<style scoped>

#main-content {
  background-color: white;
  padding-top: 1em;
}

#classroom_preview {
  width: 100%;
  table-layout: fixed;
}

#classroom-struct {
  display: flex;
  justify-content: center;
}

#successfullySeated {
  text-align: center;
}

.classroom-wing {
  display: flex;
  flex-direction: column;
  margin-top: 1em;
  margin-right: 1em;
  margin-bottom: 3em;
}

.classroom-wing-left-side {
  margin-left: 1em;
}

.classroom-row {
  display: flex;
  justify-content: center;
  margin-bottom: 0.1em;
}

.rowMark {
  margin-right: 2em;
  height: 2.5vh;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.prof-row {
  display: flex;
  justify-content: center;
  margin-bottom: 2em;
}

.classroom_name {
  text-align: center;
  margin-bottom: 1em;
}

.classroom {
  width: 100%;
  resize: none;
  min-height: 40em;
  background-color: white;
}

.classroom-seat {
  background-color: white;
  border-radius: 40%;
  height: 2.5vh;
  width: 1vw;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.seatMark {
  font-size: 10px;
}

.classroom-seat:hover {
  border: 2px solid black;
}

.prof {
  border-radius: 0;
  border-top: 2px solid black;
  border-left: 2px solid black;
  border-right: 2px solid black;
  border-bottom: 0;
  margin-left: 2em;
  height: 1vh;
  width: 2.5vw;
  margin: 0.5em 0.5em 0.5em 0.5em;
}

.selectSeat {
  text-align: center;
  font-size: 16px;
}

.selected {
  background-color: black;
  color: white;
}

.taken {
  background-color: black;
  border-radius: 40%;
  height: 2.5vh;
  width: 1vw;
  margin-top: 0.5em;
  margin-bottom: 0.5em;
}

.seatButton {
  border: 0;
  padding: 0.30em;
  outline: none;
  background-color: #ecf0f5;
}

.ready {
  width: 10%;
  border: 2px solid #3c8dbc;
  padding: 0.4em;
  background-color: #3c8dbc;
  margin-bottom: 2em;
  margin-top: 2em;
  color: white;
  border-radius: 2em;
  outline: none;
}

.ready:hover {
  color: #3c8dbc;
  background-color: white;
  outline: none;
}

.fixCheck {
  padding-top: 0.4em;
}

.showHideExecGroups {
  width: 10%;
  border: 2px solid black;
  padding: 0.4em;
  background-color: white;
  margin-bottom: 2em;
  margin-top: 2em;
  text-transform: uppercase;
  color: black;
  outline: none;
}

.seatMarksButton {
  border: 0;
  background-color: white;
  outline: none;
  font-size: 22px;
  border: 1px solid white;
}

.seatMarksButton:hover {
  border: 1px solid black;
  border-radius: 100%;
}

.groupColor {
  display: block;
}

.colorSettings {
  display: flex;
  justify-content: center;
}

.colorPicker {
  list-style-type: none;
}

.colorPickerButton {
  padding: 0.5em;
  border-radius: 100%;
  border: 0;
  outline: none;
  color: white;
}

.colorPickerButton:hover {
  border: 2px dashed black;
}

.selectedColorButton {
  border: 2px solid black;
  color: black;
}

.activeProperty {
  color: red;
}

.colorGroup {
  margin-left: 0.5em;
  border-radius: 1em;
  border: 0;
  color: white;
  font-style: bold;
  outline: none;
}

.showHideExecGroups:hover {
  border: 2px dashed black;
  border-radius: 2em;
}


.fa-check:hover {
  margin: 0;
  padding: 0;
}

.fa:hover {
  margin: 0;
  padding: 0;
}

</style>



// WEBPACK FOOTER //
// StopCheating.vue?71a74248